export default __webpack_public_path__ + "static/media/stake-more-dot.5ca3cf5e.svg";